import {combineReducers} from 'redux';
import * as types from '../actions/types';
import {isEmpty} from '../utilities/validation';
import flashMessage from './flash-messages';

const initialState = {
    isAuthenticated: false,
    user: {},
    users: [],
    institutions: {},
    list:[
        {gr_br_te_1: ''},
        {gr_br_te_2: ''},
        {gr_br_te_3: ''},
        {gr_br_te_4: ''},
        {gr_br_te_5: ''}
    ]
};

const auth  = (state, action) => {
    // console.log(action.users);
    if (isEmpty(action.users)) {
        return {...initialState};
    }
    return {
        ...state,
        isAuthenticated: !isEmpty(localStorage.getItem('jwtToken')),
        user: action.user || initialState.user,
        users: action.users || [],
        contentTypes: action.contentTypes || [],
        assignment : (action.recordData)?action.recordData : []//joyson
    };
};

export function captionsFlag(state = false, action) {
    switch (action.type) {
        case types.SET_CAPTIONS_FLAG:
            return action.flag;
        default:
            return state;
    }
}

export function pauseFlag(state = false, action) {
    switch (action.type) {
        case types.SET_PAUSE_FLAG:
            return action.flag;
        default:
            return state;
    }
}

export function answers(state = initialState, action) {
    let list = state.list;
    switch (action.type) {
        case types.SAVE_ANSWER:
            // Store student answer in store
            Object.keys(action.answer)
                .forEach(function eachKey(key) {
                    list[key] = action.answer[key];
                });
            return {
                ...state,
                list: list,
                student_answers: list,
                users:action.users // joyson
            };
        case types.SAVE_ANSWERS:
            // Store student answers in store
            Object.keys(list).forEach(function (key) {
                delete list[key];
            });
            Object.keys(action.answers)
                .forEach(function eachKey(key) {
                    list[key] = action.answers[key];
                });
            return {
                ...state,
                list: list,
                student_answers: list,
                users:action.users // joyson
            };
        case types.SET_ANSWERS:
            // Set student answers so that they can be displayed
            return Object.assign({}, state, {answers: action.answers});
        default:
            return state;
    }
}

const jreApp = combineReducers({
    captionsFlag,
    pauseFlag,
    answers,
    auth,
    flashMessage
});

export default jreApp;



// WEBPACK FOOTER //
// ./src/js/reducers/jreApp.js